import { render, staticRenderFns } from "./OutboundApi.vue?vue&type=template&id=dd9a25ca&"
import script from "./OutboundApi.vue?vue&type=script&lang=js&"
export * from "./OutboundApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports